import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import PageHero from "@/components/PageHero";

export default function Stories() {
  const [stories, setStories] = useState([]);
  const [cat, setCat] = useState("ALL");

  useEffect(() => {
    api.get("/stories").then((r) => setStories(r.data)).catch(() => {});
  }, []);

  const cats = ["ALL", ...new Set(stories.map((s) => s.category))];
  const visible = cat === "ALL" ? stories : stories.filter((s) => s.category === cat);

  return (
    <div data-testid="stories-page">
      <PageHero eyebrow="SPORTIVE STORIES" title="Stories From the Road."
        subtitle="Destination stories, runner journeys, behind-the-event features, community voices and travel guides."
        image="https://images.unsplash.com/photo-1651678938586-affccc71c270?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxydXJhbCUyMGluZGlhJTIwdmlsbGFnZSUyMGdyZWVuJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc4OTA2ODIwN3ww&ixlib=rb-4.1.0&q=85" />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="flex flex-wrap gap-2">
          {cats.map((c) => (
            <button key={c} data-testid={`story-filter-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setCat(c)}
              className={`rounded-full border px-4 py-1.5 font-mono text-[11px] tracking-[0.12em] transition-colors ${cat === c ? "border-brand-olive bg-brand-olive/15 text-brand-olive" : "border-brand-line text-slate-400 hover:border-brand-cyan hover:text-brand-cyan"}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {visible.map((s) => (
            <Link to={`/stories/${s.slug}`} key={s.slug} data-testid={`story-card-${s.slug}`} className="card-k group overflow-hidden transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-brand-cyan/50">
              <div className="h-48 overflow-hidden">
                <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between">
                  <p className="font-mono text-[10px] tracking-[0.2em] text-brand-olive">{s.category}</p>
                  <p className="font-mono text-[10px] text-slate-600">{s.date}</p>
                </div>
                <h3 className="mt-3 font-display text-2xl font-bold leading-snug text-white">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-400 line-clamp-2">{s.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-brand-cyan">READ STORY <ArrowRight size={13} /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
